// extracted by mini-css-extract-plugin
export default {"container":"To-z","brandName":"Uo-z","productName":"Vo-z","productNamePdpEnhancements":"Wo-z","breakLongProductName":"Xo-z"};